import _ from 'lodash';

export default function checkForNestedColumnWidth(localStorageColumns, columns) {
	if (localStorageColumns) {
		_.forEach(localStorageColumns, outerElement => {
			if (_.has(outerElement, 'nestedColumns')) {
				_.forEach(columns, innerElement => {
					if (innerElement.title === outerElement.title) {
						_.forEach(innerElement.nestedColumns, innerNestedColumn => {
							_.forEach(outerElement.nestedColumns, outerNestedColumn => {
								if (outerNestedColumn.key === innerNestedColumn.key) {
									innerNestedColumn.width = outerNestedColumn.width;
									return;
								}
							});
						});
					}
				});
			}
		});
	}
}
